export const UPDATE_PRODUCT_REQUEST = 'UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';
export const RESET_UPDATE_PRODUCT_STATE = 'RESET_UPDATE_PRODUCT_STATE';

export const updateProductRequest = (id, formData) => ({
    type: UPDATE_PRODUCT_REQUEST,
    payload: { id, formData },
});

export const updateProductSuccess = (data) => ({
    type: UPDATE_PRODUCT_SUCCESS,
    payload: data,
});

export const updateProductFailure = (error) => ({
    type: UPDATE_PRODUCT_FAILURE,
    payload: error,
});

export const resetUpdateProductState = () => ({
    type: RESET_UPDATE_PRODUCT_STATE
})